import OpenableTitle from '../OpenableTitle';
import { Space, Typography } from 'antd';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import ContentTypeTag, {
  hasSkillCheckContent,
} from '../../../components/AddContent/ContentTypeTag';
import { screenSm } from 'constants/styles/breakpoints';
import { durationFromSecs } from 'utils/helpers';
import { BottomDataWrapper, GroupItemDataWrapper, VerticalDivider } from '../styles';
import { IContentItem } from 'contexts/playlists/types';
import { CourseLearningArea } from '../../styles';

interface ILearningPathItemData {
  data: IContentItem;
  onOpen?(): void;
  toggleDetails?(): void;
}

const CourseDifficulty = styled(Typography.Text)`
  display: none;

  ${screenSm} {
    display: initial;

    text-transform: capitalize;
    font-weight: 450;
    font-size: 12px;
    line-height: 14px;
    color: #57575c;
  }
`;

const LearningPathItemData = ({
  data,
  toggleDetails,
  onOpen,
}: ILearningPathItemData): JSX.Element => {
  const {
    content_type,
    difficulty,
    name,
    duration_in_seconds,
    main_learning_area,
    learning_areas,
    instructors,
  } = data;
  const learningAreaName = main_learning_area || learning_areas?.[0];
  const instructorName = instructors?.[0]?.name || '';

  const handleMobileToogle = () => {
    isMobile && toggleDetails();
  };

  return (
    <>
      <GroupItemDataWrapper onClick={handleMobileToogle}>
        <Space>
          <ContentTypeTag value={content_type} has_skill_check_labs={hasSkillCheckContent(data)} />
          <CourseDifficulty>{difficulty}</CourseDifficulty>
        </Space>
        <OpenableTitle onOpen={onOpen}>{name}</OpenableTitle>
        <BottomDataWrapper>
          <CourseLearningArea value={learningAreaName}>{learningAreaName}</CourseLearningArea>
          {instructorName && (
            <>
              <VerticalDivider />
              {instructorName}
            </>
          )}
          <VerticalDivider />
          {durationFromSecs(duration_in_seconds)}
        </BottomDataWrapper>
      </GroupItemDataWrapper>
    </>
  );
};

export default LearningPathItemData;
